import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <div className="bg-gradient-to-r from-white to-[#FEF3E2] rounded-3xl p-8 md:p-12 border border-[#D4850A]/20 flex flex-col md:flex-row items-center gap-8 md:gap-12 shadow-lg" data-id="element-66">
          <div className="flex-shrink-0" data-id="element-67">
            <div className="w-32 h-32 md:w-40 md:h-40 bg-[#D4850A]/10 rounded-full flex items-center justify-center border-4 border-[#D4850A]/20" data-id="element-68">
              <ShieldCheckIcon className="w-16 h-16 md:w-20 md:h-20 text-[#D4850A]" data-id="element-69" />
            </div>
          </div>

          <div data-id="element-70">
            <h2 className="text-3xl font-bold mb-4 text-[#3D2B1F]" data-id="element-71">
              Garantía Total de <span className="text-[#D4850A]" data-id="element-72">45 Días</span>
            </h2>
            <p className="text-lg text-[#6B5344] mb-4" data-id="element-73">
              Una vez que completes tu compra vas a poder descargar el libro
              inmediatamente y empezar a preparar tus primeros budines hoy
              mismo.
            </p>
            <p className="text-lg text-[#6B5344]" data-id="element-74">
              Si por cualquier motivo sentís que este libro no cumplió tus
              expectativas, simplemente pedís el reembolso y{' '}
              <strong className="text-[#3D2B1F]" data-id="element-75">
                te devolvemos el dinero. Sin preguntas.
              </strong>
            </p>
          </div>
        </div>
      </div>
    </section>;
}